module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0075.jpg?v=0d90f9a3";